<template>
  <div id="app" :style="{transform: `scale(${scale})`}">
    <router-view/>
  </div>
</template>
<script>
export default {
  data () {
    return {
      scale: 1
    }
  },
  mounted () {
    this.autofit()
  },
  methods: {
    autofit () {
      this.scale = document.body.clientWidth / 1920
    }
  }
}
</script>
<style lang="scss">
html, body, #app {
  padding: 0;
  margin: 0;
  width: 100%;
  height: 100%;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  transform-origin: left top;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

@font-face {
  font-family: 'pangmenzhengdao';
  src: url('./assets/SourceHanSansCN-Bold.ttf') format('truetype');
}
</style>
